<template>
  <!-- Incoming messages -->
  <div class="received-chats">
    <div class="received-chats-img">
      <img :src="`http://localhost:9000/story/${avatar.filename}`" />
    </div>
    <div class="received-msg">
      <div class="received-msg-inbox">
        <p>
          {{ message.content }}
        </p>
        <span class="time">18:06 PM | July 24</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["message", "avatar"],
  data() {
    return {
      // avatar: this.$store.getters["profile/getAvatar"],
    };
  },
  setup() {},
};
</script>

<style scoped>
img {
  width: 50px;
  height: 50px;
  vertical-align: middle;
  border-style: none;
  border-radius: 100%;
}
/* Styling the avatar  */
received-chats-img {
  display: inline-block;
  width: 50px;
  float: left;
}
.received-msg {
  display: inline-block;
  padding: 0 0 0 10px;
  vertical-align: top;
  width: 92%;
}
.received-msg-inbox {
  width: 57%;
}

.received-msg-inbox p {
  background: #efefef none repeat scroll 0 0;
  border-radius: 10px;
  color: #646464;
  font-size: 14px;
  /* margin-left: 1rem; */
  padding: 1rem;
  width: 100%;
  box-shadow: rgb(0 0 0 / 25%) 0px 5px 5px 2px;
}
p {
  overflow-wrap: break-word;
}

/* Styling the msg-sent time  */
.time {
  color: #777;
  display: block;
  font-size: 12px;
  margin: 8px 0 0;
}
@media only screen and (max-device-width: 850px) {
  *,
  .time {
    font-size: 28px;
  }
  img {
    width: 65px;
  }
  .received-msg-inbox p {
    font-size: 28px;
  }
}

@media only screen and (max-device-width: 450px) {
  *,
  .time {
    font-size: 28px;
  }
  img {
    width: 65px;
  }
  .received-msg-inbox p {
    font-size: 28px;
  }
}
</style>